import { PluginFunction, PluginOptions } from './plugin';

const AppendWindowMeta: PluginFunction = ({ method, message }: PluginOptions) => {
  // We need to use typeof checks here to avoid ReferenceErrors when code is
  // later transpiled during production builds.
  if (typeof message == 'object' && typeof window !== 'undefined') {
    message.url = window.location.href;
  }

  return method(message);
};

export { AppendWindowMeta };
